import React from 'react'

export default function LoaderSpinner({loaderOpacity = 1, customStyle = {}}) {
    return (
        <div style={{opacity: loaderOpacity, ...customStyle}} className="spinnerLoaderWrapper d-flex justify-content-center align-items-center">
            <div className="spinner"></div>
        </div>
    )
}
